type Theme = 'light' | 'dark';

const THEME_COLORS: Record<Theme, string> = {
  light: '#B87333',
  dark: '#241708',
};

const root = document.documentElement;
const themeMeta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');

function applyTheme(theme: Theme): void {
  root.setAttribute('data-theme', theme);
  localStorage.setItem('talos-theme', theme);
  themeMeta?.setAttribute('content', THEME_COLORS[theme]);
}

function currentTheme(): Theme {
  return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
}

function initThemeToggle(): void {
  const toggle = document.getElementById('theme-toggle');
  toggle?.addEventListener('click', () => {
    applyTheme(currentTheme() === 'dark' ? 'light' : 'dark');
  });
}

function initYear(): void {
  const yearEl = document.getElementById('year');
  if (yearEl) {
    yearEl.textContent = String(new Date().getFullYear());
  }
}

initThemeToggle();
initYear();
